module.exports = __webpack_public_path__ + "static/media/text_white.f3d7d7eb.svg";